import React from 'react';

import './App.css';
import Index from './pages/Index';

export default function App() {
  return <Index />;
}
